import React from 'react'
import { Link } from 'react-router-dom'

function Navbar() {
    return (
        <nav>
            <div className=" nav container">
                <h1 className="logo"> <i className="fab fa-github"></i>Find GitHub</h1>
                <ul className="nav__child">
                    <li className="nav__child-link">
                        <Link className="link" to="/">Home</Link>
                    </li>
                    <li className="nav__child-link">
                        <Link className="link" to="/about">About</Link>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Navbar
